/* eslint-disable @typescript-eslint/no-unused-vars */
import styled from "styled-components";
import { TextField as TextFieldMUI } from "@mui/material";
import materialUI from "../../../../../../material-UI";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  width: 436px;
  flex: 1;

  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  margin-left: 16px;
  padding: 36px 0 24px 0;
  border-radius: 16px 0px 0px 16px;
`;

export const Title = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  color: #333333;
  letter-spacing: -0.01em;
  margin-left: 14px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RowTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 32px 0 32px;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ColumnAlign = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 36px;
  padding: 0 8px 0 8px;
`;

export const Space: any = styled.div`
  min-height: ${(props: any) => props.space}px;
`;

export const DesktopDatePicker = styled(materialUI.DesktopDatePicker)`
  .Mui-disabled {
    background-color: rgb(242, 244, 248);
  }
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  width: 100%;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    height: 44px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 4.5px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: #2d5bff !important;
    }
  }
  .MuiOutlinedInput-input {
    padding-top: 10.5px;
    padding-bottom: 10.5px;
  }
  &:hover {
    fieldset {
      border-color: #2d5bff !important; // Adiciona a cor azul no hover
    }
  }

  &:focus {
    fieldset {
      border-color: #2d5bff !important; // Adiciona a cor azul no foco
    }
  }
`;

export const InputLable = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  margin-bottom: 8px;
`;

export const LocalizationProvider = styled(materialUI.LocalizationProvider)``;

export const Scroll = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1;
  padding: 0 32px 0 32px;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-width: 1px;
  border-style: solid;
  border-color: #c0c0c0;
  padding: 16px 32px 0 32px;
`;

export const CustomTextField = styled(TextFieldMUI)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    height: "40px",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderWith: "2px",
    borderColor: "#2D5BFF",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderWith: "2px",
    borderColor: "#2D5BFF",
  },
  "&.Mui-focused fieldset": {
    borderWith: "2px",
    borderColor: "#2D5BFF !important",
  },
}));
